export default __webpack_public_path__ + "6ee247bcdd47ab115610d38455027e34.png";